/**
 * Feature switches for things that exist in the app but are turned off for now.
 *
 * COINS (🪙) — turned OFF 2026-10-10 (Jens): an extra currency next to stars/points.
 *   What exists: every approved task gives the member +1 coin on top of its points
 *   (`users.coins`, updated in supabase/functions/task-action `awardPoints`). The counter is still
 *   maintained in the database, so nothing is lost while the feature is hidden.
 *   Where it was shown: Rewards page header ("🪙 N Your Coins"), the Coins row on the profile, and
 *   "Coins: N" in the admin member list — all wrapped in `FEATURES.coins` checks.
 *   Why off: stars/points are enough for now; two currencies confused users.
 *   To turn on later: set `coins: true` below. If coins get their own use (e.g. an avatar shop),
 *   design what they buy first. Note: in code, `user.stars` is an old alias of `coins`, while the
 *   ⭐ stars users see are the points.
 */
/*
 * PAYMENTS — groundwork built 2026-10-12, OFF until launch (plan: Payments & subscriptions).
 *   What exists: a 30-day trial per family (families.trial_ends_at), an exempt flag
 *   (families.billing_exempt), family_subscriptions (filled by the Lemon Squeezy webhook, not built
 *   yet) and one access rule on the server (supabase/functions/_shared/billing.ts) that get-family
 *   sends as family.billing. With the switch on: admins get Settings → Subscription, a banner in the
 *   last 7 days of the trial / after a failed payment, and everyone gets a paywall once access
 *   has ended (children: "ask a grown-up").
 *   Still missing before turning it on: Lemon Squeezy checkout + webhook + customer portal, prices,
 *   the beta-tester decision, and server-side blocking of writes for expired families.
 */
export const FEATURES = {
  coins: false,
  payments: false,
} as const;
